import SlsEmpresaClient from '@/api/Cadastros/info-organizacionais/sls-empresa.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSEmpresaService {
  constructor() {
    this.client = new SlsEmpresaClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os empresa');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Empresa');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Empresa');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Empresa');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Empresa');
    }
  }
}
